var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48347(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68bbff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48347",
    "data-name": "Group 48347",
    transform: "translate(-858 -8437)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(858 8437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M14.539,7.208,14.149,11H11.193V22H6.752V11H4.539V7.208H6.752V4.925C6.752,1.842,8,0,11.559,0h2.955V3.792H12.664c-1.38,0-1.472.534-1.472,1.522V7.208h3.346Z",
    transform: "translate(878.461 8456)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48347);
export default __webpack_public_path__ + "static/media/Group 48347.17adc8a61c0d6bc1377bf388976a3648.svg";
export { ForwardRef as ReactComponent };